import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { filter, withLatestFrom, concatMap } from 'rxjs/operators';
import * as release from '@webapp/sdk/release';
import { Action } from 'redux';
import { PublishRelease } from '../action-creators';
import { UpdateTrackSuccess } from '../../tracks/action-creators';
import { UPDATE_TRACK_SUCCESS } from '../../tracks/actions';
import AppState from '../../state';

export const republishAfterTrackUpdateEpic = (action$: Observable<Action>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Action, UpdateTrackSuccess>(UPDATE_TRACK_SUCCESS),
    withLatestFrom(state$),
    filter(([action, state]) => !!(action.republish && state.artist.active?.id && action.track.releaseId)),
    concatMap(async ([action, state]) => {

      const artistId = state.artist.active?.id as string;
      const releaseId = action.track.releaseId as string;

      const published = await release.get(artistId, releaseId);

      return new PublishRelease(artistId, releaseId, published);
    })
  )